import { grey } from "@mui/material/colors";

export const textInfo = {
	fontSize: 14,
	color: grey[600],
};

export const tableBox = {
	width: "130px",
	padding: "6px 2px",
	...textInfo,
	textAlign: "center",
	fontSize: 14,
	display: "flex",
	justifyContent: "center",
	borderRight: `1px solid ${grey[200]}`,
	"&:last-child": {
		borderRight: "none",
	},
};

export const mrpBox = {
	width: 120,
	padding: "5px 0px",
	height: 50,
};

export const storeInfoBox = {
	width: "100%",
	display: "flex",
	columnGap: 4,
};

export const storeInfoColumn = {
	width: "45%",
	...textInfo,
};

export const infoPanelSx = {
	width: "100%",
	boxSizing: "border-box",
	backgroundColor: "white",
	border: `1px solid ${grey[300]}`,
	borderRadius: 3,
	boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
	p: 3,
};

export const infoMetricValueSx = {
	fontSize: 18,
	fontWeight: "bold",
	color: grey[900],
};

export const historyHeaderCellSx = {
	...textInfo,
	fontWeight: "bold",
	fontSize: 13,
	textTransform: "uppercase",
	letterSpacing: "0.05em",
	color: grey[700],
};

export const bpGridSx = {
	width: "100%",
	borderRadius: "8px",
	minHeight: 300,
	maxHeight: 480,
	"&.MuiDataGrid-root": {
		boxSizing: "border-box",
		width: "100% !important",
		boxShadow: `2px 2px 5px ${grey[200]}`,
	},
	"& .MuiDataGrid-main": {
		width: "100%",
	},
	"& .MuiDataGrid-virtualScroller": {
		width: "100%",
	},
	"& .MuiDataGrid-cell": {
		padding: 0,
		borderBottom: "0px",
	},
	"& .MuiDataGrid-columnHeader": {
		padding: 0,
	},
	".MuiDataGrid-columnSeparator": {
		display: "none",
	},
};

/** Sleek home-page grids (plans + stores) */
export const bpHomeGridSx = {
	height: "100%",
	minHeight: 0,
	width: "100%",
	border: `1px solid ${grey[200]}`,
	borderRadius: 2.5,
	bgcolor: "#fff",
	fontSize: 13,
	overflow: "hidden",
	"& .MuiDataGrid-main": {
		overflow: "hidden",
	},
	"& .MuiDataGrid-virtualScroller": {
		overflowX: "auto !important",
		overflowY: "auto !important",
	},
	"& .MuiDataGrid-columnHeaders": {
		bgcolor: grey[100],
		borderBottom: `1px solid ${grey[300]}`,
	},
	"& .MuiDataGrid-columnHeader": {
		bgcolor: grey[100],
		borderRight: `1px solid ${grey[200]}`,
		px: 1.25,
		outline: "none !important",
		"&:last-of-type": {
			borderRight: "none",
		},
	},
	"& .MuiDataGrid-columnHeaderTitle": {
		fontSize: 11,
		fontWeight: 700,
		letterSpacing: "0.06em",
		textTransform: "uppercase",
		color: grey[700],
	},
	"& .MuiDataGrid-cell": {
		borderRight: `1px solid ${grey[200]}`,
		borderBottom: `1px solid ${grey[200]}`,
		px: 1.25,
		display: "flex",
		alignItems: "center",
		outline: "none !important",
		fontSize: 13,
		color: grey[800],
		bgcolor: "#fff",
		"&:last-of-type": {
			borderRight: "none",
		},
	},
	"& .MuiDataGrid-row": {
		transition: "background-color 0.12s ease",
		"&:hover": {
			cursor: "pointer",
			bgcolor: grey[50],
		},
		"&:hover .MuiDataGrid-cell": {
			bgcolor: grey[50],
		},
	},
	"& .MuiDataGrid-footerContainer": {
		minHeight: 44,
		borderTop: `1px solid ${grey[300]}`,
		bgcolor: grey[50],
	},
	"& .MuiDataGrid-columnSeparator": {
		visibility: "visible",
		color: grey[400],
		"&:hover": {
			color: grey[700],
		},
		"& .MuiDataGrid-iconSeparator": {
			color: "inherit",
		},
	},
	"& .MuiDataGrid-withBorderColor": {
		borderColor: grey[200],
	},
	"& .green": {
		backgroundColor: "rgba(154, 222, 123, 0.28) !important",
	},
	"& .yellow": {
		backgroundColor: "rgba(249, 251, 231, 1) !important",
	},
};

export const pageStackSx = {
	width: "1200px",
	margin: "auto",
	pt: 2,
	spacing: 3,
};
